import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MenuBookOutlined from "@mui/icons-material/MenuBookOutlined";
import { alpha, useTheme } from "@mui/material/styles";

const TERMOS: Array<{ titulo: string; texto: string }> = [
  {
    titulo: "Faturamento bruto — loja (valor cobrado)",
    texto:
      "Soma das receitas de venda confirmadas no período, na data efetiva do lançamento financeiro. Não desconta estornos — use Faturamento líquido para a visão após cancelamentos.",
  },
  {
    titulo: "Estornos — loja",
    texto:
      "Soma das despesas de estorno de pedidos confirmadas no período (data efetiva). Reflete devoluções ao cliente por cancelamento de pedido pago.",
  },
  {
    titulo: "Faturamento líquido — loja",
    texto:
      "Faturamento bruto menos estornos de pedidos no período. Não inclui taxas de gateway — essas aparecem nos lançamentos e no DRE Gerencial.",
  },
  {
    titulo: "Receita comercial — loja (pedidos)",
    texto:
      "Soma dos totais comerciais dos pedidos distintos com receita no período (produtos + frete − desconto). Não inclui juros de parcelamento cobrados a mais na fatura do cartão.",
  },
  {
    titulo: "Juros de parcelamento — loja",
    texto:
      "Diferença entre faturamento bruto e receita comercial quando o cliente parcela no cartão com juros. Não altera o valor do pedido na loja, apenas o total cobrado na operadora.",
  },
  {
    titulo: "Ticket médio — loja",
    texto:
      "Faturamento bruto dividido pelo número de pedidos distintos com receita confirmada no período.",
  },
  {
    titulo: "Faturamento bruto — inscrições (valor recebido)",
    texto:
      "Soma do valor cobrado (pagamento.total) das inscrições pagas no período, filtradas por data de pagamento ou data de inscrição — mesmo critério do extrato Confirmadas. Pode incluir juros de parcelamento no cartão.",
  },
  {
    titulo: "Receita de inscrições",
    texto:
      "Soma dos totais comerciais (totalInscricao) das inscrições pagas no período — corresponde ao total Confirmadas no extrato. Não inclui juros de parcelamento cobrados a mais na fatura do cartão.",
  },
  {
    titulo: "Juros de parcelamento — inscrições",
    texto:
      "Diferença entre faturamento bruto e receita de inscrições quando o pagamento é parcelado com juros no cartão.",
  },
  {
    titulo: "Ticket médio — inscrições",
    texto:
      "Faturamento bruto de inscrições dividido pelo número de inscrições pagas no período.",
  },
  {
    titulo: "Inscrições em eventos",
    texto:
      "Aparecem na seção Vendas de inscrições com base na data de pagamento ou de inscrição, alinhado ao extrato Confirmadas. Para visão por competência ou consolidada com despesas do evento, use o relatório Por evento ou o DRE Gerencial.",
  },
  {
    titulo: "Resultado (competência)",
    texto:
      "Lucro bruto, lucro operacional e margens calculados por data de competência (não por data de pagamento). Inclui CMV dos pedidos, taxas de gateway, estornos e despesas de títulos pagos no período. Pode diferir do faturamento bruto/líquido das seções acima.",
  },
  {
    titulo: "Lucro bruto",
    texto:
      "Receita líquida (após taxas e estornos) menos CMV dos produtos vendidos na loja. Inscrições entram na receita, mas não possuem CMV automático — custos do evento aparecem nas despesas operacionais.",
  },
  {
    titulo: "Lucro operacional",
    texto:
      "Lucro bruto menos despesas operacionais (títulos a pagar quitados no período + ajustes). É o indicador principal de resultado do negócio no DRE Gerencial.",
  },
  {
    titulo: "Faturamento líquido vs. receita líquida (DRE)",
    texto:
      "Faturamento líquido (loja) = valor cobrado − estornos, por data efetiva, sem descontar taxas de gateway. Receita líquida (DRE) = receita bruta − taxas − estornos, por competência, consolidando loja, inscrições, patrocínios e fretes.",
  },
];

export default function FinanceiroGlossario() {
  const theme = useTheme();
  const mode = theme.palette.mode;
  const borderSoft =
    mode === "dark" ? alpha("#90caf9", 0.35) : alpha("#1976d2", 0.18);

  return (
    <Accordion
      disableGutters
      elevation={0}
      sx={{
        marginTop: 2,
        marginBottom: 2,
        borderRadius: "16px !important",
        border: `1px solid ${borderSoft}`,
        "&:before": { display: "none" },
        overflow: "hidden",
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          px: 2,
          minHeight: 48,
          "& .MuiAccordionSummary-content": {
            my: 1,
            gap: 1.5,
            alignItems: "center",
          },
        }}
      >
        <MenuBookOutlined fontSize="small" color="action" />
        <Typography variant="subtitle2" fontWeight={700}>
          Como ler este dashboard
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ px: 2, pt: 0, pb: 2 }}>
        {TERMOS.map((t) => (
          <Typography
            key={t.titulo}
            variant="body2"
            color="text.secondary"
            sx={{ mb: 1.25, lineHeight: 1.55 }}
          >
            <Typography
              component="span"
              variant="body2"
              fontWeight={700}
              color="text.primary"
            >
              {t.titulo}:{" "}
            </Typography>
            {t.texto}
          </Typography>
        ))}
      </AccordionDetails>
    </Accordion>
  );
}
